<template>
    <div>
        <div class="vx-card p-6">
            <div class="vx-row">
                <div class="vx-col md:w-1/2 w-full my-auto">
                    <h3>Thông tin từ khóa hạn chế</h3>
                </div>
            </div>

            <div class="vx-row">
                <div class="vx-col w-full mt-4">
                    <label class="vs-input--label required">Từ khóa hạn chế</label>
                    <vs-textarea class="w-full" v-model="keyword"/>
                </div>
            </div>

            <div class="vx-row">
                <div class="vx-col w-full">
                    <div class="mt-4 flex flex-wrap items-center justify-end">
                        <vs-button class="ml-auto mt-2" @click="saveChanges" :disabled="!validateForm">{{
                                `${isUpdate ? $t('button.update') : $t('button.create')}`
                            }}
                        </vs-button>
                        <vs-button class="ml-4 mt-2" type="border" color="warning"
                                   @click="$router.push('/user/restricted-keywords')">
                            {{ $t('button.back') }}
                        </vs-button>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>

import vSelect from 'vue-select';
import VueUploadMultipleImage from '../../../../components/VueUploadMultipleImage';
import authConfig from '@/../auth_config.json';

export default {
    components: {
    },
    data() {
        return {
            isUpdate: false,
            images: [],
            keyword: this.$route.query.keyword,
        }
    },

    computed: {
        validateForm() {
            return !this.errors.any()
        },
    },
    async created() {

        if (this.$route.query.id) {
            this.isUpdate = true;
            await this.findServiceById(this.$route.query.id);
        }
    },

    methods: {
        async saveChanges(evt) {
            //Validate data
            evt.preventDefault();
            let key = this.keyword.split(';').map(el => el.trim());

            let body = {
                keywords: key,
            }
            if (this.$route.query.id) body['id'] = this.$route.query.id;
            let url = this.isUpdate ? '/beauty-foul-keyword/update' : '/beauty-foul-keyword/create';

            // Goi API
            this.$vs.loading();
            this.$crm.post(url, body).then(() => {
                this.$vs.notify({
                    color: 'success',
                    text: `${this.isUpdate ? this.$t('menuNewFeed.updateKeyword') : this.$t('menuNewFeed.addKeyword')}`,
                    iconPack: 'feather',
                    icon: 'icon-check-circle',
                });
                setTimeout(() => {
                    this.$router.push('/user/restricted-keywords');
                }, 1000)
                this.$vs.loading.close();
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                })
            })
        },

        findServiceById(id) {
            return new Promise((resolve, reject) => {
                this.$vs.loading();
                this.$crm.post(`/beauty-foul-keyword/find-by-condition`, {id: id}).then(res => {
                    this.keyword = res.data.content[0].keyword;
                    resolve()
                    this.$vs.loading.close();
                }).catch(err => {
                    reject()
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                })
            })
        },

    }

}
</script>

<style scoped>
</style>
